import { createSlice } from "@reduxjs/toolkit";
import { mapTdcTo3dd } from "../../components/TicketSingleGroup/pages/HomeGroup/pages/GroupSelectYourSeat/Map3D/map3DHelper";

export const singleGroupSlice = createSlice({
  name: "singleGroup",
  initialState: {
    type: "",
    currentPage: "ticket-single-group",
    currentTab: "",
    groupNumOfTickets: 49,
    pricingTier: { tier: 1, tierName: "20-99" },
    groupGameSelected: "",
    selectedSeatsNodes: [],
    mainSections: [],
    selectedMainSection: "",
    selectedSeats: {},
    sectionsAvailableSeats: {},
    maxSeatsReached: false,
    isIsolated: false,
  },
  reducers: {
    setType: (state, action) => {
      state.type = action.payload;
    },
    setSelectedMainSection: (state, action) => {
      state.selectedMainSection = action.payload;
    },
    setMainSections: (state, action) => {
      state.mainSections = action.payload;
    },
    setGroupNumOfTickets: (state, action) => {
      state.groupNumOfTickets = action.payload;
    },
    setPricingTier: (state, action) => {
      state.pricingTier = action.payload;
    },
    setGroupGameSelected: (state, action) => {
      state.groupGameSelected = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setCurrentTab: (state, action) => {
      state.currentTab = action.payload;
    },
    setSelectedSeatsBySection: (state, action) => {
      const selectedSeats = state.selectedSeats;
      const { section, seats } = action.payload;
      if (selectedSeats.hasOwnProperty(section)) {
        const duplicates = seats.filter((seat) =>
          selectedSeats[section].includes(seat)
        );
        const uniqueSeats = seats.filter(
          (seat) => !selectedSeats[section].includes(seat)
        );
        selectedSeats[section].push(...uniqueSeats);
        if (duplicates.length > 0) {
          console.log(
            `Warning: ${duplicates.join(", ")} already selected in ${section}`
          );
        }
      } else {
        selectedSeats[section] = [...seats];
      }
      // state.selectedSeats[action.payload.section] = action.payload.seats;
    },
    setSelectedSeatsNodes: (state, action) => {
      const selectedSeats = state.selectedSeatsNodes;
      const nodeIds = action.payload;
      const allNodesToAdd = [];

      nodeIds.forEach((node) => {
        const isUnique = !selectedSeats.includes(node);

        if (isUnique) {
          allNodesToAdd.push(node);
        } else {
          console.log("Already exist!");
        }
      });
      state.selectedSeatsNodes = [
        ...state.selectedSeatsNodes,
        ...allNodesToAdd,
      ];
    },
    removeSelectedSeatsNodes: (state, action) => {
      const nodeIdsToDelete = action.payload;

      const updatedSelectedSeats = state.selectedSeatsNodes.filter(
        (node) => nodeIdsToDelete !== node
      );

      state.selectedSeatsNodes = updatedSelectedSeats;
    },
    removeSelectedSeatsBySection(state, action) {
      const { section, seats } = action.payload;

      const updatedSeats = state.selectedSeats[section].slice(); // Create a copy of the array
      seats.forEach((seat) => {
        const index = updatedSeats.indexOf(seat);
        if (index !== -1) {
          updatedSeats.splice(index, 1); // Remove the seat from the array
        }
      });

      state.selectedSeats = {
        ...state.selectedSeats,
        [section]: updatedSeats,
      };
    },
    setSectionsAvailableSeats: (state, action) => {
      const sectionsAvailableSeats = state.sectionsAvailableSeats;
      const { section, seats } = action.payload;
      if (sectionsAvailableSeats.hasOwnProperty(section)) {
        const duplicates = seats.filter((seat) =>
          sectionsAvailableSeats[section].includes(seat)
        );
        const uniqueSeats = seats.filter(
          (seat) => !sectionsAvailableSeats[section].includes(seat)
        );
        sectionsAvailableSeats[section].push(...uniqueSeats);
        if (duplicates.length > 0) {
          // console.log(
          //   `Warning: ${duplicates.join(", ")} already selected in ${section}`
          // );
        }
      } else {
        sectionsAvailableSeats[section] = [...seats];
      }
    },
    setMaxSeatsReached: (state, action) => {
      // const allSelectedSeats = Object.values(state.selectedSeats).flat();
      // state.maxSeatsReached =
      //   state.selectedSeatsNodes?.length >= state.groupNumOfTickets;
      state.maxSeatsReached = action.payload;
    },
    setIsIsolated: (state, action) => {
      state.isIsolated = action.payload;
    },
    setResetSeats: (state) => {
      state.selectedSeats = {};
      state.selectedSeatsNodes = [];
      // state.mainSections = [];
      state.selectedMainSection = "";
      state.sectionsAvailableSeats = {};
      state.maxSeatsReached = false;
      state.isIsolated = false;
    },
  },
});

export const {
  setType,
  setCurrentPage,
  setCurrentTab,
  setGroupGameSelected,
  setGroupNumOfTickets,
  setPricingTier,
  setSelectedSeatsBySection,
  setSelectedSeatsNodes,
  removeSelectedSeatsNodes,
  removeSelectedSeatsBySection,
  setSectionsAvailableSeats,
  setMaxSeatsReached,
  setResetSeats,
  setIsIsolated,
  setSelectedMainSection,
  setMainSections,
} = singleGroupSlice.actions;

export default singleGroupSlice.reducer;

// Getters
export const getMaxSeatsReached = ({ singleGroup }) => {
  return singleGroup.maxSeatsReached;
};
export const getSelectedMainSection = ({ singleGroup }) => {
  return singleGroup.selectedMainSection;
};
export const getMainSections = ({ singleGroup }) => {
  return singleGroup.mainSections;
};
export const getIsIsolated = ({ singleGroup }) => {
  return singleGroup.isIsolated;
};
export const getSelectedSeatsNodes = ({ singleGroup }) => {
  return singleGroup.selectedSeatsNodes;
};
export const getAllSectionsAvailableSeats = ({ singleGroup }) => {
  const allSectionsAvailableSeats = Object.values(
    singleGroup.sectionsAvailableSeats
  ).flat();
  return allSectionsAvailableSeats;
};
export const getAllSelectedSeats3dd = ({ singleGroup }) => {
  const allSeats = Object.values(singleGroup.selectedSeats).flat();
  return allSeats;
};
export const getSelectedSeatsBySection =
  (sectionName) =>
  ({ singleGroup }) => {
    return singleGroup.selectedSeats[sectionName];
  };
export const getAllSelectedSeatsTdc = ({ singleGroup }) => {
  const allSeats = Object.values(singleGroup.selectedSeats).flat();
  const allSeatsTo3dd = allSeats?.map((seat) => {
    const seatArr = seat.split("-");
    const seatRow = seatArr[1];
    const seatNumber = seatArr[2];
    const TdcSeat = singleGroup.sectionsAvailableSeats[seatArr[0]].find(
      (obj) => obj.row === seatRow && obj.seatNumber === seatNumber
    );
    return TdcSeat;
  });
  return allSeatsTo3dd;
};
